<template>
  <div
    class="home-card d-flex flex-column align-items-end w-25 pointer"
    v-if="!comingSoon"
    @click="emitCardClick"
  >
    <!-- Title (Mobile only) -->
    <div
      class="w-100 py-1 d-lg-none text-secondary font-weight-bold text-center align-self-center bg-light border-top shadow-sm"
    >
      {{ title }}
    </div>
    <!-- Image -->
    <img
      class="img-fluid mt-1"
      :src="`${$pathPrefix}/assets/welcome-pics/${path}.png`"
      :alt="title"
    />
    <!-- Description -->
    <!-- <p class="product-type-description px-3 w-100">
      {{ $t(`welcome.${path}`) }}
    </p> -->
    <p
      class="product-type-description px-3 w-100"
      v-html="$t(`welcome.${path}`)"
    ></p>

    <!-- Button -->
    <button
      class="mr-3 mb-3 float-right bg-saka-orange px-4 py-2 rounded-pill text-white mt-auto border-0"
      @click.stop="emitCardClick"
    >
      {{ $t("step-forward") }}
    </button>
  </div>
  <!-- Coming Soon Card -->
  <div class="home-card d-flex flex-column align-items-end w-25 pointer" v-else>
    <div
      class="w-100 py-1 d-lg-none text-secondary font-weight-bold text-center align-self-center bg-light border-top shadow-sm"
    >
      {{ title }}
    </div>
    <img
      class="img-fluid mt-1"
      :src="`${$pathPrefix}/assets/welcome-pics/${path}.png`"
      :alt="title"
    />
    <p class="product-type-description px-3 w-100">
      {{ $t(`welcome.${path}`) }}
    </p>
    <a
      class="coming-soon-link mr-3 mb-3 float-right border border-saka-orange px-4 py-2 rounded-pill text-saka-orange mt-auto text-decoration-none pointer-events-none"
      href="#"
      disabled
    >
      {{ $t("coming soon") }}
    </a>
  </div>
</template>

<script>
export default {
  name: "HomeCard",
  props: {
    path: { type: String, default: "" },
    comingSoon: { type: Boolean, default: false },
    title: { type: String, default: "" },
  },
  methods: {
    emitCardClick() {
      if (!this.comingSoon) {
        this.$emit("card-click", { path: this.path, title: this.title });
      }
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.coming-soon-link:hover {
  color: #ff6b00;
  text-decoration: none;
}
.home-card {
  width: 50%;
  cursor: pointer;
}
@media (min-width: 960px) {
  .home-card {
    width: 25%;
  }
}
</style>
